export default __webpack_public_path__ + "static/media/avatar-poseidon.ca418a06.svg";